<template>
<div v-if="isModalShown">
     <loading-component v-if="isLoading"></loading-component>
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-md">
              <div class="modal-content g-mt-170 g-z-index-1">
                  <div class="modal-body">
                    <div class="close_btn" v-on:click="CloseModal()"></div>
                        <div v-if="ResetForm"> 
                            <div class="passwordReset-header">
                                <!-- <p class="modal-title">My Account</p> -->
                                <p class="modal-title">Reset Your Password</p>
                                <p class="modal-description">Enter your email address below and we'll email you a link to reset your password.</p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-mb-10 g-pt-20">
                                <div class="form-group">
                                    <label class="reset_info_label">Enter Email Address</label>
                                    <input name="email" type="email" class="form-control login_input" v-on:keyup="ResetValidation()" v-model="RequestEmail" v-validate="'required|email'" data-vv-as="email address" oninput="this.value = this.value.toLowerCase()">
                                    <p class="error-message" v-show="errors.has('email')">{{ errors.first('email') }}</p>
                                    <p v-if="!errors.first('email')" class="error-message">{{errorMessage}}</p>
                                </div>
                                <div class="form-group text-center g-mt-20">
                                    <button  v-on:click="ForgotPassword()" class="btn btn-default g-font-size-16 u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-17 g-rounded-10 g-px-25">Email Password Reset</button>
                                </div>
                            </div>
                        </div>

                        
                        <div v-if="ResetStatus">
                        <div class="passwordReset-header">
                            <p class="modal-title">Success!</p>
                            <!-- <p class="modal-description">You can now reset your password. Kindly check your email for your request.</p> -->
                            <p class="modal-description">Please check your e-mail for authorization to reset your password.</p>
                            <button  v-on:click="CloseModal()" class="btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-default g-rounded-10 g-px-25">Close</button>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="passwordReset-header">
                                </div>
                            </div>
                        </div>
                        </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>       
</template>
<script>
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
    components: {LoadingComponent},
    data() {
        return {
            isModalShown: true,
            RequestEmail: "",
            errorMessage: null,
            ResetStatus: false,
            ResetForm: true,
            isLoading: false

        }
    },
    methods: {
        validatePortal() {
            const currentUrl = window.location.href;
            return currentUrl.includes("championsforsight") ? "CFS" : "CLTL";
        },
        CloseModal() {
            this.isModalShown = false;
            this.$emit("clicked");
            document.body.classList.remove("body-overflow");
        },
        ResetValidation(){
            this.errorMessage= "";
        },
        ForgotPassword() {
            this.isLoading = true;
            axios.post("/Account/ForgotPassword", {"EmailAddress":this.RequestEmail, "PortalType": this.validatePortal()},{ 
                "headers": {
                    "Content-Type": "application/json"  } })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.ResetForm = !_this.ResetForm;
            _this.ResetStatus = !_this.ResetStatus;

          } else {
            _this.errorMessage = response.data.errorMessage;
            console.log(response.data.errorMessage);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
        }
    }
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?d9f66cb2